/**
 * Sizes of the phone layout's fixed chrome (below md), shared by the shell
 * and the mobile pages so content and toasts clear the bars.
 */

/** The mobile AppBar's height, px. */
export const MOBILE_APPBAR_HEIGHT = 56;

/** The bottom navigation bar's height, px, before the safe area. */
export const MOBILE_BOTTOM_BAR_HEIGHT = 56;

/** The iOS home-bar inset (0 elsewhere). Needs viewport-fit=cover. */
export const SAFE_AREA_BOTTOM = 'env(safe-area-inset-bottom, 0px)';

/** A CSS `bottom` that sits `extraPx` above the bottom bar and its safe
 *  area: aboveBottomBar(8) is 'calc(64px + env(safe-area-inset-bottom, 0px))'. */
export const aboveBottomBar = (extraPx: number = 0): string =>
  `calc(${MOBILE_BOTTOM_BAR_HEIGHT + extraPx}px + ${SAFE_AREA_BOTTOM})`;

/** The shell main area's horizontal padding (theme spacing units), so a
 *  mobile page can run a strip edge to edge with a negative margin. */
export const MOBILE_MAIN_PX = 3;
